import type OccupancyStatus from 'app/frontend/types/custom/OccupancyStatus'
import { mapIdToFaction } from '../utils'

export const statusVariant: Record<
  OccupancyStatus,
  'default' | 'outline' | 'secondary'
> = {
  requested: 'outline',
  approved: 'default',
  rejected: 'secondary',
  claimed: 'default',
}

export const choiceLabels: Record<number, string> = {
  0: 'Claimed',
  1: '1st',
  2: '2nd',
  3: '3rd',
  4: 'Added',
}

export const choiceTitles: Record<number, string> = {
  1: 'First',
  2: 'Second',
  3: 'Third',
}

export const rankedChoiceColor: Record<number, string> = {
  1: 'text-[#ffd700]',
  2: 'text-[#c0c0c0]',
  3: 'text-[#c28957]',
}

export const rankedChoiceIconClass = (rankedChoice: number) =>
  rankedChoiceColor[rankedChoice] ?? 'text-primary'

export const statusClassName: Record<OccupancyStatus, string> = {
  requested: 'text-warning-foreground',
  approved: 'text-success-foreground',
  rejected: 'text-destructive-foreground',
  claimed: 'text-success-foreground',
}

export const plotImageUrl = (mapId: number, plotId: string | number) => {
  return `https://data.wowaudit.com/img/housing/plots/plot_${
    mapIdToFaction[mapId.toString() as keyof typeof mapIdToFaction]
  }_${plotId}.jpg`
}

export const houseIconUrl =
  'https://data.wowaudit.com/img/housing/icon_house.png'
